import type { IframePoolOrderItem } from '../api';

/** Safe parse of `offer.price`. Returns null for empty / NaN /
 *  zero values so callers can decide whether to bail out. */
function parsePrice(price: string): number | null {
  const n = parseFloat(price);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * `profit = fairMarketValue − packPrice`. Returns `null` when we
 * can't compute the difference (missing / non-finite numbers) or
 * when the profit is not positive — caller decides whether to
 * fall back to a plain FMV-only display.
 *
 * Visual components (ProfitLine, FmvCaption, FmvOnly) live in
 * sibling files so each can be lit by its own reveal stage.
 */
export function computeProfit(
  item: IframePoolOrderItem,
  packPrice: string,
): number | null {
  const { fairMarketValue } = item;
  if (fairMarketValue == null || !Number.isFinite(fairMarketValue)) return null;
  const cost = parsePrice(packPrice);
  if (cost == null) return null;
  const profit = fairMarketValue - cost;
  return profit > 0 ? profit : null;
}
